import create from 'zustand/vanilla';

const navStore = create((set) => ({
  open: false,
  openSet: (val) => set({ open: val }),
}));

export default navStore;
